import * as React from "react";
import { Profile } from "../../../models/Profile";

interface Props {
  profile?: Profile;
  disabled: boolean;
  onChange: (e: React.FormEvent<HTMLInputElement>) => void;
}

export const ProfileFormOptions = (props: Props) => {
  return (
    <div className="form-group row">
      <label className="col-sm-2">
        Rights
      </label>
      <div className="col-sm-10">
        <div className="form-check">
          <input type="checkbox"
            name="profileTab"
            checked={props.profile.profileTab}
            className="form-check-input"
            disabled={props.disabled}
            onChange={props.onChange}
            id="profileRights" />
          <label className="form-check-label"
            htmlFor="profileRights">
            Edit Profiles
          </label>
        </div>
        <div className="form-check">
          <input type="checkbox"
            name="viewAreas"
            onChange={props.onChange}
            checked={props.profile.viewAreas}
            className="form-check-input"
            disabled={props.disabled || props.profile.areaTab}
            id="areaRightsView" />
          <label className="form-check-label"
            htmlFor="areaRightsView">
            View Areas
          </label>
        </div>
        <div className="form-check">
          <input type="checkbox"
            name="areaTab"
            onChange={props.onChange}
            checked={props.profile.areaTab}
            className="form-check-input"
            disabled={props.disabled}
            id="areaRights" />
          <label className="form-check-label"
            htmlFor="areaRights">
            Edit Areas
          </label>
        </div>
        <div className="form-check">
          <input type="checkbox"
            name="viewUsers"
            checked={props.profile.viewUsers}
            onChange={props.onChange}
            className="form-check-input"
            disabled={props.disabled || props.profile.userTab}
            id="userRightsView" />
          <label className="form-check-label"
            htmlFor="userRightsView">
            View Users
          </label>
        </div>
        <div className="form-check">
          <input type="checkbox"
            name="userTab"
            checked={props.profile.userTab}
            onChange={props.onChange}
            className="form-check-input"
            disabled={props.disabled}
            id="userRights" />
          <label className="form-check-label"
            htmlFor="userRights">
            Edit Users
          </label>
        </div>
        <div className="form-check">
          <input type="checkbox"
            name="createEditProject"
            checked={props.profile.createEditProject}
            onChange={props.onChange}
            className="form-check-input"
            disabled={props.disabled}
            id="projectRights" />
          <label className="form-check-label"
            htmlFor="projectRights">
            Edit Projects
          </label>
        </div>
        <div className="form-check">
          <input type="checkbox"
            name="importExport"
            checked={props.profile.importExport}
            onChange={props.onChange}
            className="form-check-input"
            disabled={props.disabled}
            id="importExportRights" />
          <label className="form-check-label"
            htmlFor="importExportRights">
            Import / Export
          </label>
        </div>
        <div className="form-check">
          <input type="checkbox"
            name="printReports"
            checked={props.profile.printReports}
            onChange={props.onChange}
            className="form-check-input"
            disabled={props.disabled}
            id="printRights" />
          <label className="form-check-label"
            htmlFor="printRights">
            Print All Project Reports
          </label>
        </div>
        <div className="form-check">
          <input type="checkbox"
            name="createCustomDatasheet"
            checked={props.profile.createCustomDatasheet}
            onChange={props.onChange}
            className="form-check-input"
            disabled={props.disabled}
            id="customDataSheetRights" />
          <label className="form-check-label"
            htmlFor="customDataSheetRights">
            Custom Datasheets
          </label>
        </div>
        <div className="form-check">
          <input type="checkbox"
            name="editSites"
            checked={props.profile.editSites}
            onChange={props.onChange}
            className="form-check-input"
            disabled={props.disabled}
            id="editSitesRights" />
          <label className="form-check-label"
            htmlFor="editSitesRights">
            Edit Sites
          </label>
        </div>
      </div>
    </div>
  );
}

